

































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeSalasEReservasStore, { RegraReservaSalaFrequenciaEnum } from '@/components/Backoffice/Store/BackofficeSalasEReservasStore'
import { onlyNumber, timeout } from '@/utils/common'
import moment from 'moment'

@Component
export default class ModalBackofficeRecorrencia extends Vue {
  $refs!: {
    formRecorrencia: any,
    dialogRecorrenciaDataInicio: any,
    dialogRecorrenciaDataFim: any,
  }

  formRecorrenciaRules = {
    valid: false,
    dataFim: [(v: any) => this.validateDataFim(v)],
  }

  validateDataFim(v: any) {
    if (!v) return 'Campo obrigatório.'
    if (new Date(this.getBackofficeSalasEReservasStore.mininumDateForDataFim).getTime() > new Date(v).getTime()) return 'Data inválida.'
    return true
  }

  modalRecorrenciaDataInicio: boolean = false
  modalRecorrenciaDataFim: boolean = false

  get computedRecorrenciaDataInicio() {
    return this.getBackofficeSalasEReservasStore.regraReservaSala.recorrencia.dataInicio
      ? moment(this.getBackofficeSalasEReservasStore.regraReservaSala.recorrencia.dataInicio).format('DD/MM/YYYY')
      : ''
  }

  get computedRecorrenciaDataFim() {
    return this.getBackofficeSalasEReservasStore.regraReservaSala.recorrencia.dataFim
      ? moment(this.getBackofficeSalasEReservasStore.regraReservaSala.recorrencia.dataFim).format('DD/MM/YYYY')
      : ''
  }

  get minDate() {
    return new Date().toISOString().substring(0, 10)
  }

  get minDateFim() {
    return this.getBackofficeSalasEReservasStore.regraReservaSala.recorrencia.dataInicio
  }

  get maxDateFim() {
    return moment(this.getBackofficeSalasEReservasStore.regraReservaSala.recorrencia.dataInicio).add(3, 'years').format('YYYY-MM-DD')
  }

  get getBackofficeSalasEReservasStore() {
    return getModule(BackofficeSalasEReservasStore, this.$store)
  }

  get showRecurrencyModal() { return this.getBackofficeSalasEReservasStore.modal.frequencia }
  set showRecurrencyModal(value: boolean) { this.getBackofficeSalasEReservasStore.setModal({ name: 'frequencia', value }) }

  get tipoRepeticao() {
    switch (this.regraReservaSala.recorrencia.frequencia) {
      case RegraReservaSalaFrequenciaEnum.Semanal:
        return 'semana(s)'
      case RegraReservaSalaFrequenciaEnum.Mensal:
        return 'mes(es)'
      case RegraReservaSalaFrequenciaEnum.Anual:
        return 'ano(s)'
      default:
        return 'dia(s)'
    }
  }

  get regraReservaSala() { return this.getBackofficeSalasEReservasStore.regraReservaSala }

  onlyNumberUtil(value: any) {
    return onlyNumber(value)
  }

  @Watch('showRecurrencyModal')
  async onChangeShowRecurrencyModal(value: boolean) {
    if (!value) {
      this.$refs.formRecorrencia.resetValidation()
    }
  }

  async preventIfLessThanOneChecked(e: any) {
    if (!e.target.checked && this.regraReservaSala.recorrencia.diaDaSemana!.length < 1) {
      await timeout(0)
      // @ts-ignore
      this.regraReservaSala.recorrencia.diaDaSemana.push(Number(e.target.value))
    }
  }

  getDayOfTheWeek(day: number = 1) {
    return ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'][day]
  }

  formatDaysOfTheWeek() {
    return Array.isArray(this.regraReservaSala.recorrencia.diaDaSemana)
      ? this.replaceLast(this.regraReservaSala.recorrencia.diaDaSemana.sort().map((day: number) => this.getDayOfTheWeek(day)).join(', '), /, /, ' e ')
      : this.regraReservaSala.recorrencia.diaDaSemana
  }

  replaceLast(str: string, pattern: RegExp, replacement: string) {
    const match = typeof pattern === 'string' ? pattern : (str.match(new RegExp(pattern.source, 'g')) || []).slice(-1)[0]
    if (!match) return str
    const last = str.lastIndexOf(match)
    return last !== -1 ? `${str.slice(0, last)}${replacement}${str.slice(last + match.length)}` : str
  }

  formatHorario() {
    const { horaInicio, horaFim } = this.regraReservaSala
    return `das ${(horaInicio as string).substring(0, 5)} às ${(horaFim as string).substring(0, 5)}`
  }

  formatDataInicio() {
    const { dataInicio, diaDaSemana, frequencia } = this.regraReservaSala.recorrencia
    const aPartirDe = moment(dataInicio).format('DD/MM/YYYY')
    let ocorrencia = ''

    if (frequencia === RegraReservaSalaFrequenciaEnum.Semanal) {
      ocorrencia = diaDaSemana.length === 7 ? 'todos os dias' : `, ${this.formatDaysOfTheWeek()}`
    }

    if (frequencia === RegraReservaSalaFrequenciaEnum.Mensal) {
      ocorrencia = ` no dia ${this.regraReservaSala.recorrencia.diaDoMes} de cada mês`
    }

    return `${ocorrencia} a partir de ${aPartirDe}`
  }

  formatDataFim() {
    const { dataFim } = this.regraReservaSala.recorrencia
    return !['', null, undefined].includes(dataFim) ? ` até ${moment(dataFim).format('DD/MM/YYYY')}` : ''
  }

  formatFrequencia() {
    const { frequencia } = this.regraReservaSala.recorrencia

    if (frequencia === RegraReservaSalaFrequenciaEnum.Diario) {
      return `Ocorre ${this.regraReservaSala.recorrencia.intervalo < 2 ? `todos os dias ${this.formatHorario()}` : `${this.formatHorario()} a cada ${this.regraReservaSala.recorrencia.intervalo} dias `}`
    }

    if (frequencia === RegraReservaSalaFrequenciaEnum.Semanal) {
      return `Ocorre ${this.regraReservaSala.recorrencia.intervalo < 2 ? `toda semana ${this.formatHorario()}` : `${this.formatHorario()} a cada ${this.regraReservaSala.recorrencia.intervalo} semanas `}`
    }

    if (frequencia === RegraReservaSalaFrequenciaEnum.Mensal) {
      return `Ocorre ${this.regraReservaSala.recorrencia.intervalo < 2 ? `todo mês ${this.formatHorario()}` : `${this.formatHorario()} a cada ${this.regraReservaSala.recorrencia.intervalo} meses `}`
    }
    return ''
  }

  get recurrencyDescription() {
    const frequenciaDescription = `${this.formatFrequencia()}${this.formatDataInicio()}${this.formatDataFim()}.`
    this.getBackofficeSalasEReservasStore.setRecurrencyDescription(frequenciaDescription)
    return frequenciaDescription
  }
}
